import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { patientStories } from '../mock';

const storyLinks = {
  'richard-post-op-knee': '/news/post-surgical-rehab-why-follow-a-plan',
  'ella-vestibular': '/news/vestibular-rehab-for-dizziness-and-vertigo',
  'sofia-postnatal': '/news/pelvic-health-physiotherapy-common-concerns',
};

const StoryCard = ({ story }) => (
  <Link to={storyLinks[story.slug] || '/news'} className="group relative block rounded-[20px] overflow-hidden aspect-[4/5] bg-neutral-200">
    <img src={story.image} alt={story.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
    <div className="absolute inset-x-0 bottom-0 p-6 flex items-end gap-3">
      <span className="w-10 h-10 rounded-full bg-white grid place-items-center shrink-0 group-hover:bg-[#CA0028] group-hover:text-white transition-colors">
        <ArrowRight size={14} />
      </span>
      <p className="text-white text-[16px] font-medium leading-snug">{story.title}</p>
    </div>
  </Link>
);

const PatientStories = () => {
  return (
    <section id="stories" className="py-16 lg:py-24 bg-neutral-50">
      <div className="max-w-[1240px] mx-auto px-6">
        <div className="grid lg:grid-cols-[420px_1fr] gap-14 items-start">
          <div>
            <h2 className="text-[40px] lg:text-[54px] leading-[0.98] font-bold tracking-tight text-neutral-900">
              Recovery Pathways <br />
              <span className="font-serif-italic font-normal">we support</span>
            </h2>
            <p className="mt-6 text-[15px] leading-relaxed text-neutral-600 max-w-sm">
              From knee surgery to dizziness and postpartum activity, these examples show common
              rehab goals our physiotherapy team can help patients work toward.
            </p>
            <Link to="/news" className="mt-6 inline-flex items-center gap-1 text-[14px] font-medium text-[#CA0028] group">
              See More Stories
              <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {patientStories.map((s) => (
              <StoryCard key={s.id} story={s} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PatientStories;
